import { FC } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10, TablesWidget5 } from "../../../smallnation/partials/widgets"



const AddCompany: FC = () => {
      const intl = useIntl()
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Add Company'})}</PageTitle>
          <TablesWidget5 className={""}/>
        </>
      )
    }
export {AddCompany}